import { render } from "./DatabaseManager.vue?vue&type=template&id=01101156&scoped=true"
import script from "./DatabaseManager.vue?vue&type=script&lang=js"
export * from "./DatabaseManager.vue?vue&type=script&lang=js"

import "./DatabaseManager.vue?vue&type=style&index=0&id=01101156&scoped=true&lang=scss"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01101156"]])

export default __exports__